import { isCompanyUser } from "@/utils/roleStorage";

export const TaleText = ({
  role,
  children,
  className,
  applyEffect = true,
  style = {},
  ...props
}) => {
  const businessStyle = {
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };
  const normalStyle = {
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };
  return (
    <span
      className={`${
        !applyEffect
          ? ""
          : isCompanyUser()
          ? "bg-tale-business"
          : "bg-tale-normal"
      }  ${className ?? ""}`}
      style={{
        ...style,
        ...(!applyEffect
          ? {}
          : isCompanyUser()
          ? businessStyle
          : normalStyle),
      }}
      {...props}
    >
      {children}
    </span>
  );
};
